function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Drag(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.646 20.854l-2.182-2.182a.5.5 0 01.707-.707l1.329 1.328 1-14.586v14.586l1.328-1.328a.5.5 0 11.708.707l-2.182 2.182a.5.5 0 01-.708 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.646 3.146L9.464 5.328a.5.5 0 00.707.708L11.5 4.707v14.586l1-14.586 1.328 1.329a.5.5 0 10.708-.708l-2.182-2.182a.5.5 0 00-.708 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.854 12.354l-2.182 2.182a.5.5 0 11-.707-.708l1.328-1.328-14.586-1h14.586l-1.328-1.328a.5.5 0 11.707-.708l2.182 2.182a.5.5 0 010 .708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.146 12.354l2.182 2.182a.5.5 0 10.708-.708L4.707 12.5h14.586l-14.586-1 1.329-1.328a.5.5 0 00-.708-.708l-2.182 2.182a.5.5 0 000 .708z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Drag);
export default ForwardRef;